import { Button } from '@mui/material';
import { useState } from 'react';
import ExoDialog from '../../exo/ExoDialog';
import { ECTextBlocks } from '../../email-system/ECTextBlocks';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { htmlToQuillDelta } from '../../exo/rich-text-editor/quillHtmlToDelta.ts';

export const TextBlockStyle = ({ onInsert, textBlockType }) => {
  const [open, setOpen] = useState(false);

  // insert blocks
  const handleInsertBlock = ({ text }) => {
    setOpen(false);
    onInsert(htmlToQuillDelta(text));
  };

  return (
    <>
      <Button
        className="grouped"
        onClick={() => setOpen(true)}
        sx={{ minWidth: '37px' }}
      >
        <div className="w-4 h-4 flex justify-center items-center">
          <TextSnippetIcon />
        </div>
      </Button>
      <ExoDialog open={open} limitWidth onClose={() => setOpen(false)}>
        <ECTextBlocks onSelect={handleInsertBlock} type={textBlockType} />
      </ExoDialog>
    </>
  );
};
